import axios from 'axios'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import { message } from 'antd'
import { randomWord } from 'src/helper/tool'
import sha1 from 'sha1'
import sha256 from 'sha256'
axios.defaults.baseURL = config.host
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.interceptors.request.use(function (opt) {
  return opt
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  // console.log("response", response) //返回
  if (response.data.code && response.data.code !== 0) {
    // if (response.data.res == null) {
    //   response.data.res = []
    // }
    logicError(response.data) //逻辑错误
    // return Promise.reject(response) //如果不注释，会不能取消滚动loading
  }
  return response.data || {} //正确
}, function (error) { //网络错误
  error && message.error('请退出重新登录',3)
  return Promise.reject(error)
})

function logicError(d) {
  d.msg && message.error(d.msg)
}

function httpMethod(method, url, data, dataExt, headers, readUrl) {
  let map = {
    data: data || {},
    ...dataExt
  }
  const accesstoken = localstorage.get('userToken')
  
  if (accesstoken == '') {
     return message.error('请退出重新登录',3)
  }
  // if (method === 'post') {
    headers = headers || { 'content-type': 'application/json' }
    headers['Authorization'] = `Bearer ${accesstoken}`
  // }


  // if (readUrl == true) {
  //   url = config.hostRead + url
  // }

  let opt = { method, url }
  if (headers) opt.headers = headers
  switch (method) {
    case 'get':
      opt.params = map.data
      break
    default:
      opt.data = map.data
      break
  }
  return axios(opt)
}

function httpMethodRead(method, url, data, dataExt, headers) {
  return httpMethod(method, url, data, dataExt, headers, true)
}

function httpUpload(method, data, cb) {
  let formData = new FormData()
  let xhr = new XMLHttpRequest()
  Object.keys(data).map(key => {
    formData.append(key, data[key])
  })
  xhr.open('POST', config.uploadHost, true)
  const accesstoken = localstorage.get('userToken')
  xhr.setRequestHeader('Authorization', `Bearer ${accesstoken}`)
  cb = cb || {}

  xhr.onload = function (e) {
    console.log('onload', JSON.parse(this.response))
    cb && cb(JSON.parse(this.response))
  }
  xhr.send(formData)
}

export default {
  request: axios.request,
  get(...args) {
    return httpMethod('get', ...args)
  },
  delete(...args) {
    return httpMethod('delete', ...args)
  },
  head: axios.head,
  post(...args) {
    return httpMethod('post', ...args)
  },
  postRead(url, query) {
    return httpMethod('post', ...args)
  },
  put(...args) {
    return httpMethod('put', ...args)
  },
  patch(...args) {
    return httpMethod('patch', ...args)
  },
  upload(...args) {
    return httpUpload('post', ...args)
  }
}



// WEBPACK FOOTER //
// ./helper/http.js